import { render, staticRenderFns } from "./Dns.vue?vue&type=template&id=77c6ed87&scoped=true"
import script from "./Dns.vue?vue&type=script&lang=js"
export * from "./Dns.vue?vue&type=script&lang=js"
import style0 from "./Dns.vue?vue&type=style&index=0&id=77c6ed87&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77c6ed87",
  null
  
)

export default component.exports